<template>
  <header class="header">
    <div class="page">
        <NuxtLink to="/" class="branding"><img src="/images/wpLogo.svg" alt="logo" ></NuxtLink>
      <nav>
        <button aria-label="menu" class="bt_menu" @click="toggleMenu">
          <i class="fas fa-bars"/><span>{{$t('navigation.showMenu')}}}</span>
        </button>
        <ul class="cats">
<!--                    <li><a href="/" ></a></li>-->
<!--                    <li><a href="/">Música</a></li>-->
<!--                    <li><a href="/">Deportes</a></li>-->
<!--                    <li><a href="/">Convenciones</a></li>-->
        </ul>
        <ul :class="menuClass">
<!--          <buttons-switch-language/>-->
<!--          <li><a href="#" @click="$refs.doubtsModal.modalVisible = true">{{$t('navigation.aboutUs')}}</a></li>-->
          <li><a href="https://servicios.woypass.com.ar" target="_blank">{{$t('services')}}</a></li>
          <li><NuxtLink to="/shows/new" class="bt">{{$t('navigation.createShow')}}</NuxtLink></li>
          <li v-if="!session.session.loggedIn"><NuxtLink to="/auth/login">{{$t('navigation.myAccount')}}</NuxtLink></li>
<!--          <buttons-switch-theme/>-->
          <li v-if="session.session.loggedIn" class="user">
            <a href="#">{{session.session.userInitials}}</a>
            <ul>
              <li><strong>{{session.session.user?.name}} {{session.session.user?.surname}}</strong></li>
              <li>
                <NuxtLink to="/user/profile">{{$t('navigation.profile')}}</NuxtLink>
              </li>
              <li>
                <NuxtLink to="/user/reservations">{{$t('navigation.myTickets')}}</NuxtLink>
              </li>
              <hr>
              <li>
                <a :href="myShowsUrl">{{$t('navigation.myShows')}}</a>
              </li>
              <li>
                <a :href="controlUrl" target="_blank">{{$t('navigation.organizerAccess')}}</a>
              </li>
              <li>
                <a href="#" @click.prevent="logout">{{$t('navigation.logout')}}</a>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  <modal-component ref="doubtsModal" :title="$t('navigation.aboutUs')">
    <p>{{$t('navigation.modalDoubts')}}</p>
    <p>{{$t('navigation.modalDoubts2')}}</p>
  </modal-component>
  </header>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import ModalComponent from "~/components/ModalComponent.vue";
import {useSessionStore} from "~/storage/session";
import api from "~/api";
import config from '~/config/config.json';

export default defineComponent({
  name: 'Navigation',
  components: {ModalComponent},
  data() {
    return {
      isMenuOpen: false,
      session: useSessionStore()
    }
  },
  computed: {
    menuClass() {
      return this.isMenuOpen ? 'menu visible' : 'menu'
    },
    controlUrl() {
      return config.CONTROL_URL;
    },
    myShowsUrl() {
      return config.MY_SHOWS_URL;
    },
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    async logout() {
      await api.Auth.logout()
      const sessionStore = useSessionStore();
      sessionStore._reset();

      window.location = '/'
    }
  }
})
</script>
